import { render, staticRenderFns } from "./packageAdd.vue?vue&type=template&id=74b76eb8&scoped=true"
import script from "./packageAdd.vue?vue&type=script&lang=js"
export * from "./packageAdd.vue?vue&type=script&lang=js"
import style0 from "./packageAdd.vue?vue&type=style&index=0&id=74b76eb8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b76eb8",
  null
  
)

export default component.exports